import { format, parseISO } from 'date-fns';

// dateはISO 8601形式で渡されるのでparseISOでparseする必要がある
export const formatDate = (date: string): string => {
  return format(parseISO(date), 'yyyy/MM/dd');
};

export const formatOmittedDate = (date: string): string => {
  return format(parseISO(date), 'yy/MM/dd');
};

export const formatOmittedDateTime = (date: string): string => {
  return format(parseISO(date), 'yy/MM/dd HH:mm');
};

export const formatISO8601 = (date: Date): string => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss+09:00");
};

export const formatNow = (formatText: string): string => {
  return format(new Date(), formatText);
};
